import { sync_command_dispatcher, async_command_dispatcher } from "@/api/client";
import { ServiceDeliveryRepository } from "../domain/ServiceDeliveryRepository";

export class  APIServiceDeliveryRepository implements ServiceDeliveryRepository {
    
    find_by_user_id(user_id: number) {
        throw new Error("Method not implemented.");
    }
    
    async find_by_id(sd_id: number) {
        throw new Error("Method not implemented.");
    }

    async find_by_criteria( crit: any[][], orderBy?: string, orderSort: 'asc' | 'desc' = 'asc', limit?: number ): Promise<any[]> {
        throw new Error("Method not implemented.");
    }

    async save(sd_id: number, company_ids: number[]) {
        return await sync_command_dispatcher.dispatch(
            'update.companies.sd',
            { sd_id: sd_id, company_ids: company_ids }
        )
        
    }

    async regenerate_invoice(charge_id: number) {
        return await async_command_dispatcher.dispatch(
            'generate.invoice',
            { charge_id: charge_id }
        )
    }
}